import $ from "jquery";
import uly from "ulysses/base";
import ko from "knockout";
import HalResource from "ulysses/api";
import URI from "URI/URI";
import markup from "ulysses/page.html";
import "ulysses/entity_service";
import "ko.mapping-latest";
import "adminlte";
import "ulysses/pubsub";

"use strict";
$(document).ready(function() {
    $(markup).appendTo($("#main-content"));
});

function _get_hash(state) {
    var hash =state.hash || "";
    if (hash.indexOf("?") >= 0)
        hash = hash.slice(0, hash.indexOf("?"));
    return hash;
}
function _get_page_loader(state) {
    var url = new URI(state.hash);
    var segments = url.segment();
    var rel = "data";

    var root = new URI(uly.url_root);
    var root_segments = root.segment();


    var keepers = [];
    $.each(segments, function(idx,val) {
        if (idx > root_segments.length || keepers.length > 0 || root_segments[idx] != segments[idx]) {
            if (val != "index.html")
                keepers.push(val);
        }

    });


    segments = keepers;
    return uly.api.get_resource(segments);
}

class Page {
    constructor() {
        let _self = this;
        Object.assign(this, {
            app_settings: {
                sidebar: ko.observable(null),
                rightsidebar: ko.observable(null),
                allow_gravatars: ko.observable(false),
                tabs: {
                    active_entity: ko.observable(null),
                    knowledge: ko.observable(null),
                    recent_activity: ko.observable(null),
                    summary_dashboard: ko.observable(null),
                    bookmarks: ko.observable(null),
                    flagged: ko.observable(null),
                    library: ko.observable(null)
                },
                show_details_menu: ko.observable(null),
                app_colour: ko.observable(null),
                app_logo: ko.observable(null),
            },
            default: {
                left:[{"type":"search"}],
                middle:[],
                right:[],
                header:{"type":"entitymaster"},
                page_resource:{ "type":"masterresult"},
                layout:"2"
            },
            collection_default:{
                left:[{"type":"search"}],
                middle:[],
                layout:"1,1,1",
                page_resource:null
            },
            settings: {
                left:ko.observableArray([]),
                middle:ko.observableArray([]),
                right:ko.observableArray([]),
                header:ko.observable(null),
                layout:ko.observable("2+1")
            },
            userprofile : {
                username:ko.observable("anonymous"),
                fullname:ko.observable(_("page_page_anonymous", "Anonymous")),
                home_page:ko.observable("login"),
                account:ko.observable(null),
                roles:ko.observableArray([]),
                picture:ko.observable(null),
                email:ko.observable(null),
                theme:ko.observable(null),
                id: ko.observable(null),
                unique_id:ko.observable(null),
                type_name: ko.observable(null),
                language: ko.observable(null),
                global_permissions: ko.observableArray([]),
                is_admin: ko.pureComputed(()=>{
                    var roles = this.userprofile.roles();
                    if (roles.indexOf("Administrator") >= 0) {
                        return true;
                    }
                    return false;
                }),
                is_user: ko.pureComputed(()=>{
                    var username = ko.unwrap(this.userprofile.username);
                    if (username && username != "anonymous") {
                        return true;
                    }
                    return false;
                }),
                has_permission: function(perm) {
                    return ko.unwrap(uly.page.userprofile.global_permissions).indexOf(perm) >= 0 ||
                        ko.unwrap(uly.page.userprofile.global_permissions).indexOf("*") >= 0
                }
            },
            title: ko.observable(_("page_page_ulysses", "Ulysses")),
            page_resource: ko.observable(null),
            active_entity_id: ko.observable(null),
            active_entity: ko.observable(null),
            ui_state: {
                wide_sidebar: ko.observable(false),
                container_class: ko.pureComputed(() => {
                    let is_wide_sidebar = ko.unwrap(this.ui_state.wide_sidebar);
                    return is_wide_sidebar ? "skin-blue sidebar-mini lgbar": "skin-blue sidebar-mini";
                }),
                title_class: ko.pureComputed(() => {
                    let is_impersonating = ko.unwrap(this.userprofile.is_impersonating);
                    let title_colour = ko.unwrap(this.app_settings.app_colour);
                    let back_class = "";
                    if (is_impersonating) {
                        back_class = "bg-maroon";
                    } else if (title_colour) { 
                        back_class = "bg-" + title_colour;
                    } else {
                        back_class = "bg-primary";
                    }
                    let imp_class = is_impersonating ? " impersonating" : "";
                    return back_class + imp_class + " navbar navbar-notfixed-top";

                })
            }
        });

        this.stylesheet = $("<style type='text/css' rel='stylesheet'/>").appendTo($("head"));
        this.update_styles();

        window.addEventListener("orientationchange", (e) => {
            this.update_styles();
            uly.publish("window.orientationchange", {"event":e, "portrait": window.orientation == 0});
        }, false);
        uly.subscribe("page.savesettings", (topic, state) => {
            this.save_settings();
        });

        this.title.subscribe(function(newvalue) {
            var old_value = document.title;
            document.title = newvalue || _("page_page_ulysses", "Ulysses");
            uly.publish("page.title.changed", {"new":newvalue, "old":old_value });
        });

        uly.subscribe("page.activate.entity", (topic, entity) => {
            this.activate_entity(entity)
        });

        this.computed_title = ko.pureComputed(() => {
            var res = this.page_resource();
            var settings = ko.toJS(this.settings);

            if (res && ko.unwrap(res.title)) {
                return ko.unwrap(res.title);
            } else if (res && ko.unwrap(res.caption)) {
                return ko.unwrap(res.caption);
            }

            var widgets = this.settings.header() || [];
            if (widgets && typeof widgets.concat == "undefined") {
                widgets = [widgets];
            }

            widgets = widgets.concat(this.settings.left() || []);
            widgets = widgets.concat(this.settings.middle() || []);
            widgets = widgets.concat(this.settings.right() || []);
            if (widgets.length) {
                var comps = $(".column .panel-wrapper :first-child");
                for (var i = 0; i < comps.length; ++i) {
                    var c = comps[i];
                    var data = ko.dataFor(c);
                    if (data && data.title) {
                        var t = ko.unwrap(data.title);
                        if (t) {
                            return t;
                        }
                    }
                }
                for (var i = 0; i < widgets.length; ++i) {
                    var w = widgets[i];
                    if (w && w.title) {
                        return ko.unwrap(w.title);
                    }
                    if (w && w.caption) {
                        return ko.unwrap(w.caption);
                    }                        
                }
            }


        });
        var self = this;
        this.computed_title.subscribe((newvalue) => {
            if (newvalue) {
                try {
                    self.title(newvalue);
                } 
                catch(e) {
                    console.error("Error setting title:", e);
                    console.log("Self=", self);
                    console.log("This=", this);
                }
            }
        })

    }

    update_app_settings(app_data) {
        this.app_settings.tabs.active_entity(app_data.active_entity ? true : false)
        this.app_settings.tabs.recent_activity(app_data.recent_activity ? true : false)
        this.app_settings.tabs.bookmarks(app_data.bookmarks ? true : false)
        this.app_settings.tabs.flagged(app_data.flagged ? true : false)
        this.app_settings.tabs.library(app_data.library ? true : false)
        this.app_settings.tabs.summary_dashboard(app_data.summary_dashboard ? true : false)
        this.app_settings.tabs.knowledge(app_data.knowledge ? true : false )

        this.app_settings.show_details_menu(app_data.details_menu ? true: false);
        this.app_settings.rightsidebar(true);
        if (app_data.has_sidebar) {
            this.app_settings.sidebar(true);//new Sidebar(this.userprofile.username));
        } else {
            this.app_settings.sidebar(false);
        }
        if (app_data.allow_gravatars) {
            this.app_settings.allow_gravatars(true);
        } else {
            this.app_settings.allow_gravatars(false);
        }
        this.app_settings.app_colour(app_data.app_colour);
        this.app_settings.app_logo(app_data.app_logo);
        this.bind();

    }        

    bind() {
        $(".modal-body").remove();
        if (!this.bound) {
            ko.applyBindings(this);
            this.bound = true;
        }
    }

    _load_data(state) {
        let self = this;

        var res = Promise.Deferred();

        var hash = _get_hash(state);
        /*
        state = _check_redirect(this, state, hash);
        if (((hash === "/" || hash === "") && state.data && state.data.link == "login")) {
            uly.actions.login();
        }
        else if (hash === "/login" && ko.unwrap(this.userprofile.is_user)) {
            uly.actions.gohome();
        }
        */
        var def = _get_page_loader(state);
        var loaded_resource = null;
        def.then((data) => {
            loaded_resource = data;
            return data;
        }, (xhr) => {
            loaded_resource = null;
            return xhr;
        }).always(function(xhr) {
            if (loaded_resource !== null){
                self.load_settings(loaded_resource).then(function(settings) {
                    res.resolve([loaded_resource, settings]);
                }, (xhr) => {
                    if (xhr && (xhr.status === "404" || xhr.status === "403")) {
                        var resource = self.page_resource();
                        if (resource) {
                            if(resource.content_type == "collection"){
                                res.resolve([resource, {data:ko.mapping.fromJS(self.collection_default)}]);
                            }else{
                                res.resolve([resource, {data:ko.mapping.fromJS(self.default)}]);
                            }
                        } else {
                            //got 404 and no resoruce. shouldnt' we reject?
                            res.reject(xhr, null);
                            //res.resolve({data:ko.mapping.fromJS($.extend({}, self.default, {"header":null}))});
                        }
                    }
                    else res.reject(xhr, null);
                });
            }else{
                res.reject(xhr, null);
            }
        });
        return res;
    }

    refresh_resource() {
        var page_res = this.page_resource();
        let self = this;
        if (page_res) {
            if (page_res.unique_id) {
                if (page_res.unique_id.indexOf("/")) {
                    uly.api.get_resource(page_res.unique_id.replace("#", "/")).then(function(result) {
                        self.page_resource(result);
                    });
                } else {
                    uly.api.get_entity(page_res.unique_id).then(function(result) {
                        self.page_resource(result);
                    });
                }
            } else {
                page_res = HalResource(page_res, true);
                page_res.refresh().done(function(data) {
                    self.page_resource(data);
                });
            }
        }
    }

    load_settings(resource) {
        var username = ko.unwrap(this.userprofile.username);
        var key = null;
        if (resource.settings_key)
            key = resource.settings_key;
        else if (resource && resource._links && resource._links.self && resource._links.self.href) {
            key = uly.utils.get_relative_resource_uri(resource._links.self.href);
            if (key.indexOf("data/") === 0)
                key = key.substring(5);
            if (key.indexOf("?")>=0)
                key = key.slice(0,key.indexOf("?"));


            if (ko.unwrap(resource.content_type))
                key = key +"/"+ko.unwrap(resource.content_type);
        }
        if (username != "anonymous") {
            return HalResource(this.userprofile)
                    .follow("uly:settings", { "key":key, "variant":uly.settings_variant });
        }
        else {
            return uly.api.start()
                    .follow("uly:settings")
                    .follow("find", {"resource":key, "variant":uly.settings_variant });
        }
    }

    clear_settings() {
        this.settings.header(null);
        this.settings.left(null);
        this.settings.right(null);
        this.settings.middle(null);
    }

    get_allowed_state(state, hash) {
        if (hash === "" || hash === "/") {
            var data = {
                link: ko.unwrap(this.userprofile.home_page) || "home",
                title: _("page_title_home", "Home")
            };
            state = uly.history.get_temporary_state(data);
        }
        if(hash != "/resetmypassword" && this.userprofile && this.userprofile.password_expiry < 0) {
            var data = {
                link: "/resetmypassword",
                title: _("page_title_resetpassword", "Reset Password")
            };
            state = uly.history.get_temporary_state(data);
        }
        return state;

    }

    reload(state) {
        if (!state) {
            state = uly.history.get_state();
        }

        uly.publish("page.refreshsettings.start", state);
        var _old_settings = ko.toJS(this.settings);

        let self = this;

        var hash = _get_hash(state);
        state = this.get_allowed_state(state, hash);
        hash = _get_hash(state);

        if (((hash === "/" || hash === "") && state.data && state.data.link == "login")) {
            uly.actions.login();
            return;
        }
        else if (hash === "/login" && ko.unwrap(this.userprofile.is_user)) {
            uly.actions.gohome();
            return;
        }

        this._last_state = state;
        this._load_data(state).then(function([resource, settings]) {
            if (self._last_state && state != self._last_state) {
                uly.publish("page.refreshsettings.end.fail", state);
                return;
            }
            self.clear_settings();
            self.page_resource(resource);
            var data = ko.unwrap(settings.data);
            self.settings.layout(data ? ko.unwrap(data.layout) : "2+1");
            self.settings.header(data ? ko.unwrap(data.header) : null);
            self.settings.left(data ? ko.unwrap(data.left) || [] :  []);
            self.settings.right(data ? ko.unwrap(data.right) || [] :  []);
            self.settings.middle(data ? ko.unwrap(data.middle) || [] :  []);
            uly.publish("page.refreshsettings.end", state);
        }).fail(function(error) {
            console.error("Could no load a valid settings for this page... showing error page", error);
            self.load_error_data(error, state);
            uly.publish("page.refreshsettings.end.fail", state);
        });

    }

    load_error_data(error, state) {
        let self = this;
        self.page_resource(null);
        self.settings.header(null);
        self.settings.left([]);
        self.settings.right([]);
        self.settings.middle([]);
        if (error && (error.status == "403" || error.status == "401") && (!this.userprofile || !ko.unwrap(this.userprofile.is_user))) {
            self.page_resource({
                "title":_("page_title_authentication_needed", "Authentication needed"),
                "snippet":"<p>{0} <a class='btn btn-primary' data-bind=\"action:'login'\" title=\"{1}\"><i class='fa fa-lock text-success' ></i>{2}</a></p>".format(
                    _("page_load_error_data_page_the_resource_requested_is_restricted_please_login_to_continue", "The resource requested is restricted. Please login to continue:"),
                    _("page_load_error_data_page_login_to_ulysses", "Login to Ulysses"),
                    _("page_load_error_data_page_login", "Login")
                ),
                "_links":{},
                "model_icon":"fa-lock",
                "model_colour":"tomato",
                "is_bare":true
            });
            self.settings.header({"type":"entitymaster", "expanded": true});
        } else {
            self.page_resource({
                "title":_("page_title_page_not_found", "Page Not Found"),
                "snippet":_("page_snippet_p_the_resource_requested_cannot_be_found_p", "<p>The resource requested cannot be found.</p>"),
                "_links":{},
                "model_icon":"fa-question-circle",
                "model_colour":"tomato",
                "is_bare":true
            });
            self.settings.header({"type":"entitymaster", "expanded": true });
        }
        if (error && error.status == "401") {
            uly.actions.login();
        }
    }

    get_persistent_settings() {
        return ko.toJS({
            "left":this.settings.left,
            "right":this.settings.right,
            "middle":this.settings.middle,
            "header":this.settings.header,
            "layout":this.settings.layout
        });
    }

    save_settings(settings) {
        let self = this;
        var resource = self.page_resource();
        if (resource != null){

            var username = ko.unwrap(this.userprofile.username);
            var key = null;
            if (resource.settings_key)
                key = resource.settings_key;
            else if (resource._links && resource._links.self && resource._links.self.href) {
                key = uly.utils.get_relative_resource_uri(resource._links.self.href);
                if (key.indexOf("data/") == 0)
                    key = key.substring(5);
                if (key.indexOf("?")>=0)
                    key = key.slice(0,key.indexOf("?"));

                if (ko.unwrap(resource.content_type))
                    key = key +"/"+ko.unwrap(resource.content_type);
            }

            if (key && username != "anonymous") {
                if (typeof settings == "undefined")
                    settings = self.get_persistent_settings();
                HalResource(this.userprofile).post("uly:settings", { "key":key, "variant":uly.settings_variant }, settings);
            }
        }
    }

    delete_settings(for_all_users) {
        let self = this;
        for_all_users = for_all_users === true;
        var resource = self.page_resource();
        if (resource != null){

            var username = ko.unwrap(this.userprofile.username);
            var key = null;
            if (resource.settings_key)
                key = resource.settings_key;
            else if (resource._links && resource._links.self && resource._links.self.href) {
                key = uly.utils.get_relative_resource_uri(resource._links.self.href);
                if (key.indexOf("data/") == 0)
                    key = key.substring(5);
                if (key.indexOf("?")>=0)
                    key = key.slice(0,key.indexOf("?"));

                if (ko.unwrap(resource.content_type))
                    key = key +"/"+ko.unwrap(resource.content_type);
            }
            if (key && username != "anonymous") {
                return HalResource(this.userprofile).delete("uly:settings", { "key":key, "variant":uly.settings_variant, "for_all":for_all_users }, null);
            }
        }
        return Promise.Deferred().reject({}).promise();
    }

    update_styles() {
        this.stylesheet.text([
            ".full-height{height:"+window.innerHeight+"px;max-height:"+window.innerHeight+"px;}",
            ".full-height .select2-results{height:"+(window.innerHeight-75)+"px;max-height:"+(window.innerHeight-75)+"px;}"
        ].join(""));
    }

    refresh_active_entity(entity_id) {
        return uly.api.get_entity(entity_id).then(function(entity) {
            uly.page.active_entity(new uly.page.searchify_item(entity));
            uly.page.active_entity_id(entity.unique_id);
            return entity;
        });
    }

    activate_entity(entity) {
        var entity_id = null;
        if (Object.isObject(entity)) {
            entity_id = ko.unwrap(entity.unique_id);
        } else if (entity.indexOf("#") > 0) {
            entity_id = entity;
        }
        if (entity_id) {
            if (this.active_entity_id() != entity_id) {
                if (this._active_entity_sub) {
                    uly.unsubscribeToChange(this.active_entity_id(), this._active_entity_sub);
                    this._active_entity_sub = null;
                }
                this._active_entity_sub = uly.subscribeToChange(entity_id, () => {
                    uly.utils.throttle(document, () => {
                        this.refresh_active_entity(this.active_entity_id());
                    }, 500);
                });
                this.refresh_active_entity(entity_id);
            }
        }
    }
}

uly.page = new Page();
